"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var config = {
    HOST: '63e6tmgyknhsdds7czdnoq4c3u.appsync-api.us-east-1.amazonaws.com',
    REGION: 'us-east-1',
    PATH: '/graphql',
    ENDPOINT: '',
};
config.ENDPOINT = "https://" + config.HOST + config.PATH;
exports.default = config;
